export interface FileData {
  name: string;
  size: string;
  type: string;
  file: File;
  sizeValid: boolean;
}

export interface submitFormRef {
  submitForm: () => { isValid: boolean; errorText?: string };
}

export const defaultCaseDeatilsFormDetails = {
  Adpvalue: "No",
  IsADPCoverage:"No",
  dateOfIncident:"",
  AccidentOccur:"",
  ConditionsDamage:"",
  CaseSubject: [""],
  CasePriority: [""],
  WhatKindOfAccidentOccured: [""],
  CaseApplicationInformation: [""],
  ApplicationInformationVersion: [""],
  ApplicationInformationVersionText: "",
  OperatingSystem: [""],
  OperatingSystemVersion: [""],
  CustomerTrackingNumber: "",
  ErrorCodes: "",
  TroubleshootingStepsTaken: "",
  IssueDescription: "",
  SoftwareRelease:'',
  IsRMA: 'no',      
  // extraField
  ProblemDescription: "",
  ISTeradeciCall: false,
  UIDS: false,
  issueSuggestions: [] as any[],
};

export const primaryContactInformation = {
  UserId: [''],
  AccountId: '',
  fullname: '',
  FirstName: '',
  LastName: '',
  PhoneNumber: '',
  Extension: '',
  AlternatePhoneNumber: '',
  AlternateExtension: '',
  Email: '',
  countryName: "",
  cpf: '',
  neighbourhood: '',
  stateInscription: '',
  countryId: [''],
  accountType: '',
  phNumCountryCode: [''],
  phNumAlternateCountryCode: [''],

  // extra field
  addsavedcontacts: 'false',
};

export const alternateContactInformation = {
  FirstName: '',
  LastName: '',
  PhoneNumber: '',
  Extension: '',
  AlternatePhoneNumber: '',
  AlternateExtension: '',
  Email: '',
  phNumCountryCode: [''],
  countryName: [''],
  phNumAlternateCountryCode: [''],
  // extra Fields
  alternateaddsavedcontacts: 'false',
  UserId: [''],
  countryId: [''],
  cpf: '',
  neighbourhood: '',
  stateInscription: '',


};

export interface alternateFormDetails {
  FirstName: string;
  LastName: string;
  PhoneNumber: string;
  Extension: string;
  AlternatePhoneNumber: string;
  AlternateExtension: string;
  Email: string;
  phNumCountryCode: string[];
  phNumAlternateCountryCode: string[];
  alternateaddsavedcontacts: string[];
  UserId: string[];
  countryId: string[];
}



export const EquipmentPhysicalAddress = {
  UserId: [''],
  isEquipmentContactSelected: false,
  NewEquipmentContact: false,
  AccountId: '',
  fullname: '',
  FirstName: '',
  LastName: '',
  PhoneNumber: '',
  Extension: '',
  AlternatePhoneNumber: '',
  AlternateExtension: '',
  contactCountryId:[''],
  Email: '',
  country: [''],
  // cpf: '',
  // neighbourhood: '',
  // stateInscription: '',
  countryId: [''],
  accountType: '',
  phNumCountryCode: [''],
  phNumAlternateCountryCode: [''],

  countryName: "",
  BindingPin: [''],
  contactphone: '',
  company: '',
  Mailstop: '',
  AddressLine1: '',
  AddressLine2: '',
  AddressLine3: '',
  City: '',
  State: '',
  ZipCode: '',
  SiteName: [''],
  EquipmentCountryName: "",
  equipmentCountry: "",
  equipmentTaxId: "",
  equipmentTaxOfficeName: "",
  countryShortCode:'',
  showparts: '100000000',

  // extrafeild
  Acknowledge: 'true',
  validatedAddress: '',
  validateBtn:''
}

export const shipingResetFileds = {
  UserId: [''],
  isEquipmentContactSelected: false,
  NewEquipmentContact: false,
  AccountId: '',
  fullname: '',
  FirstName: '',
  LastName: '',
  PhoneNumber: '',
  Extension: '',
  AlternatePhoneNumber: '',
  AlternateExtension: '',
  Email: '',
  contactCountryId:[''],
  // country: [''],
  cpf: '',
  neighbourhood: '',
  stateInscription: '',
  // countryId: [''],
  accountType: '',
  // phNumCountryCode: [''],
  phNumAlternateCountryCode: [''],
}
export const shipingSiteNameResetFileds = {
  SiteName: [''],
  AddressLine1: '',
  AddressLine2: '',
  AddressLine3: '',
  City: '',
  Mailstop: '',
  State: '',
  ZipCode: '',
  company: '',
  contactphone: '',
  fullname: '',
  country: [''],
  BindingPin: [''],
  
}

export const partShippingResetFileds = {
  UserId: [''],
  AccountId: '',
  fullname: '',
  FirstName: '',
  LastName: '',
  PhoneNumber: '',
  Extension: '',
  AlternatePhoneNumber: '',
  AlternateExtension: '',
  Email: '',
  country: [''],
  cpf: '',
  neighbourhood: '',
  stateInscription: '',
  countryId: [''],
  accountType: '',
  phNumCountryCode: [''],
  phNumAlternateCountryCode: [''],
}

export const PartShippingaddressAddress = {

  FirstName: '',
  LastName: '',
  PhoneNumber: '',
  Extension: '',
  AlternatePhoneNumber: '',
  AlternateExtension:'',
  Email: '',
  TaxId: "",
  TaxOfficeName: "",
  phNumCountryCode: [""],
  EquipmentCountryName: "",
  AddressLine1: '',
  AddressLine2: '',
  AddressLine3: '',
  Mailstop: '',
  City: '',
  State: '',
  ZipCode: '',
  country: [''],
  company: '',

  partsShippingCountry: "",
  partsShippingTaxId: "",
  partsShippingTaxOfficeName: "",
  countryShortCode:'',
  // extraFields
  countryId: [''],
  UserId: [''],
  Acknowledge: 'true',
  validatedAddressBtn: '',
  validateBtn:'',
}

export const columns = [
  {
      id: "AddressLine1",
      label: "AddressLine1",
  },
  {
      id: "AddressLine2",
      label: "AddressLine2",
  },
  {
      id: "City",
      label: "City/Town",
  },
  {
      id: "Province",
      label: "State/Province",
  },
  {
      id: "PostalCode",
      label: "Zip code/Postal code",
  },
  {
      id: "Country",
      label: "Country",
  },
];


// Payload objects

export const payloadCaseCreateRootFeilds = {
  "contactid": "85680c15-7814-e711-80fc-5065f38ad971",
  // "ainfo": "",
  // "pno": "",

  // "phNumCountryCode": "",
  // "phNumAlternateCountryCode": "",
  // "altPhNumAlternateCountryCode": "",
  // "altinfPhNumAlternateCountryCode": "",
  // "equipmentPhNumCountryCode": "",
  // "partsPhNumCountryCode": "",

  // "neighbourhood": "",
  // "CPF_CNPJ": "",
  // "StateInscription": "",


  // "countryName": "India",

  // "equipmentCountry": "",
  // "equipmentTaxId": "",
  // "equipmentTaxOfficeName": "",

  // "partsShippingCountry": "-1",
  // "partsShippingTaxId": "",
  // "partsShippingTaxOfficeName": "",

  "lcid": "1033",
  "datalang": "en-US"
}


export const payloadCaseDeatils = {
  "Adpvalue": "",
  IsADPCoverage:"",
  dateOfIncident:"",
  AccidentOccur:"",
  ConditionsDamage:"",
  "CaseSubject": "",
  "CasePriority": "",
  "WhatKindOfAccidentOccured": "",
  "CaseApplicationInformation": "",
  "ApplicationInformationVersion": "",
  "ApplicationInformationVersiontext": "",
  "OperatingSystem": "",
  "OperatingSystemVersion": "",
  "CustomerTrackingNumber": "",
  "ErrorCodes": "",
  "TroubleshootingStepsTaken": "",


  "selectedaccount": "",
  "primarysubmitterscontact": "",
  "alternatesubmittercontact": "",
  "equipmentsubmitterscontact": "",
  "shippingsubmitterscontact": "",
  "BindingPin": "",
  "addsavedcontacts": "",
  "alternateaddsavedcontacts": "",
  "showparts": "",
  "SoftwareRelease": "",
  "Productseries": "",
  "Version": "",
  "licenseKey": "",
  "deaultValue": "test harsha",
  "IssueDescription": "",
  "confirm": true
};

export const payloadPrimaryContact = {
  UserId: '',
  AccountId: '',
  fullname: '',
  FirstName: '',
  LastName: '',
  PhoneNumber: '',
  Extension: '',
  AlternatePhoneNumber: '',
  AlternateExtension: '',
  Email: '',
  countryName: '',
  // cpf: '',
  // neighbourhood: '',
  // stateInscription: '',
  countryId: '',
  accountType: '',
  phNumCountryCode: '',
  phNumAlternateCountryCode: '',
};
